import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import { FC } from "react";
import ResourceImportLayout from "../ResourceImportLayout/ResourceImportLayout";
import { useParams } from "react-router-dom";

export interface IResourceImportPage {}
export const ResourceImportPage: FC<IResourceImportPage> = () => {
  const { resourceName } = useParams();

  return (
    <AuthenticatedLayout
      pageTitle={`Import ${resourceName}`}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: `${resourceName}`, navigateTo: `/resources/${resourceName}` },
        { text: "Import T4 Slips", navigateTo: `/resources/${resourceName}/import` },
      ]}
      mainContents={<ResourceImportLayout />}
    />
  );
};
